export default __webpack_public_path__ + "static/media/register_2.1086398d.jpg";